module.exports = __webpack_public_path__ + "img/jam.67f96b2f.svg";